// Deals, Compare, and Shopping List price-matching always work with no backend —
// they read a static snapshot published by .github/workflows/scrape.yml.
//
// Set REACT_APP_BACKEND_ENABLED=true at build time to turn on everything that
// still needs the live Railway backend: auth, favourites, "For You" recommendations,
// profile, admin, the AI assistant, and receipt/photo scanning (Claude Vision).
// Default is off, so the Railway backend can be stopped without breaking the site.
export const BACKEND_ENABLED = process.env.REACT_APP_BACKEND_ENABLED === 'true';
